import * as React from 'react';
import { Html } from '../../helpers/html-helpers';

export interface IGroupSeatingMessageProps {
    groupTicketMessaging: string;
    alertComponent: boolean;
}

class GroupSeatingMessage extends React.PureComponent<IGroupSeatingMessageProps, any>{
    useTagAlert = '<use xlink:href="#icon-alert" />';

    render() {
        return (
            <div className={`group-messaging-section ${(this.props.alertComponent ? "alert" : "")}`}>
                {this.props.alertComponent ?
                    <svg className="ticket-selection-quantity-max-alert" dangerouslySetInnerHTML={{ __html: this.useTagAlert }} />
                    : null
                }
                {Html.renderParagraph(this.props.groupTicketMessaging, "caption-paragraph")}
            </div>
        );
    }
}

export default GroupSeatingMessage;